<template>
  <FloatingInput
    v-model="valueModel"
    type="text"
    :input-class="enabledEurovat ? 'rounded-bl-none rounded-tl-none border-l-0' : ''"
    :label="vatIdLabel"
    :show-valid-icon="validate"
    :error="error"
    :label-class="labelClass"
    :has-tooltip="enabledEurovat || showAbn"
    :tooltip-message="tooltipMessage"
    :is-dark-floating-label="isDarkFloatingLabel"
    :notification="notification"
    @onFocus="$emit('onFocus')"
    @onBlur="$emit('onBlur')" />
</template>

<script>
import FloatingInput from '@/components/FloatingInput';
import { validateNumberLength, validateEuropeanVatNumber } from '@/utilities/validators';
import {
  ABN_NUMBER_LENGTH,
  VAT_ID_LABEL,
  VAT_ABN_TOOLTIP_MESSAGE,
  VAT_EU_TOOLTIP_MESSAGE,
  EURO_VAT_ENABLED_COUNTRIES,
} from '@/constants';

export default {
  components: {
    FloatingInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'VAT ID',
    },
    country: {
      type: Object,
      default: () => {},
    },
    labelClass: {
      type: String,
      default: '',
    },
    isDarkFloatingLabel: {
      type: Boolean,
      default: false,
    },
    notification: {
      type: String,
      default: '',
    },
  },
  methods: {
    focusHandle() {
      this.$emit('onFocus');
    },
    blurHandle() {
      this.$emit('onBlur');
    },
  },
  computed: {
    showAbn() {
      return this.country?.id === this.$store.state.subscription.countryAustralia?.id;
    },
    enabledEurovat() {
      return EURO_VAT_ENABLED_COUNTRIES.includes(this.country?.code);
    },
    vatIdLabel() {
      return this.showAbn ? VAT_ID_LABEL.ABN : VAT_ID_LABEL.VAT;
    },
    tooltipMessage() {
      return this.showAbn
        ? VAT_ABN_TOOLTIP_MESSAGE
        : this.enabledEurovat
        ? VAT_EU_TOOLTIP_MESSAGE
        : '';
    },
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value.trim());
      },
    },
    validate() {
      if (this.showAbn) {
        return validateNumberLength(this.value.trim(), ABN_NUMBER_LENGTH);
      }
      if (this.enabledEurovat) {
        return validateEuropeanVatNumber(this.value.trim());
      }
      return;
    },
  },
};
</script>
